import { DependencyList, useEffect, useState } from "react"

type optionType = {
  immediate?: boolean;
  prefix?: string;
}

const defaultOption: optionType = {
  immediate: false,
  prefix: '',
};

/**
 * call only when data changes
 * @param callback 
 * @param states 
 * @param options - {immediate: true, prefix: ''} 
    immediate = call on initiate declaration even no data changes
    prefix = purpose prefix for debug
 * @returns 
 */
export const useStateChanged = (callback: () => any, deps: DependencyList, options : optionType=defaultOption ) => {
  const combinedOption = {...defaultOption, ...options};
  const [firstRender, setFirstRender] = useState(true);
  const [oldValues, setOldValues] = useState(JSON.stringify(deps));
  const prefixStr = combinedOption.prefix ? ':'+combinedOption.prefix: '';
  // let oldValues = JSON.stringify(states);
  return useEffect(() => {
    const theCall = async() => {
      await callback();
      setOldValues(JSON.stringify(deps));
      // oldValues = JSON.stringify(states);
    }
    // console.log(`useStateChanged${prefixStr}: useEffect`, firstRender);
    if (!firstRender || combinedOption.immediate) {
      const changed = JSON.stringify(deps) !== oldValues;
      // console.log(`useStateChanged${prefixStr}: changed?`, changed, { combinedOption });
      if (changed || (firstRender && combinedOption.immediate)) {
        console.log(`useStateChanged${prefixStr}: calling!?`);
        theCall();
      } else {
        // console.log(`useStateChanged${prefixStr}: no change`);
      }
    }
    if (firstRender) {
      setFirstRender(false);
    }
  }, deps);
}
